module.exports = __webpack_public_path__ + "img/openAccountBg.57541855.png";